import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container className="py-4">
      <div className="d-flex align-items-center mb-4">
        <Button 
          variant="link" 
          className="text-decoration-none p-0 d-flex align-items-center gap-2 text-muted hover-text-primary"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft size={14} />
          <span>{t('back')}</span>
        </Button>
      </div>

      <Card className="shadow-sm border-0">
        <Card.Body className="p-4 p-md-5">
          <h1 className="display-6 fw-bold mb-3">{t('privacy_policy_title')}</h1>
          <p className="text-muted mb-5 small">{t('legal_last_updated')}</p>
          
          <div className="legal-content">
            <p className="lead text-primary mb-5">{t('privacy_intro')}</p>
            
            <section className="mb-5">
              <h3 className="h4 fw-bold text-dark mb-3">{t('privacy_section_1_title')}</h3>
              <p className="text-muted lh-lg">{t('privacy_section_1_content')}</p>
            </section>

            <section className="mb-5">
              <h3 className="h4 fw-bold text-dark mb-3">{t('privacy_section_2_title')}</h3>
              <p className="text-muted lh-lg">{t('privacy_section_2_content')}</p>
            </section>

            <section className="mb-5">
              <h3 className="h4 fw-bold text-dark mb-3">{t('privacy_section_3_title')}</h3>
              <p className="text-muted lh-lg">{t('privacy_section_3_content')}</p>
            </section>

            <section className="mb-5">
              <h3 className="h4 fw-bold text-dark mb-3">{t('privacy_section_4_title')}</h3>
              <p className="text-muted lh-lg">{t('privacy_section_4_content')}</p>
            </section>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PrivacyPolicyPage;
